<script setup>
const props = defineProps({
    placeholder: {
        type: String,
        default: null,
    },
});
const model = defineModel();
const emit = defineEmits(['onchange']);

function handleNumberOfDevices(action) {
    if (action === 'minus' && model.value > 1) {
        model.value--;
        emit('onchange', model.value);
    } else if (action === 'plus') {
        model.value++;
        emit('onchange', model.value);
    }
}
</script>

<template>
    <div>
        <h4 class="mb-2">{{ placeholder }}</h4>

        <div class="bg-white h-14 rounded-md border-2 border-orange-400 px-8 w-full flex justify-between items-center">
            <div class="minus cursor-pointer" @click="handleNumberOfDevices('minus')">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                    fill="#FF8818">
                    <path d="M200-440v-80h560v80H200Z" />
                </svg>
            </div>
            <div class="number text-2xl font-medium text-center text-orange-400">
                {{ model }}
            </div>
            <div class="plus cursor-pointer" @click="handleNumberOfDevices('plus')">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                    fill="#FF8818">
                    <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                </svg>
            </div>
        </div>
    </div>
</template>